module.exports = __webpack_public_path__ + "static/img/img3.726e71b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel/img3.jpg
// module id = Z2/t
// module chunks = 1